export default __webpack_public_path__ + "static/media/offline.364b7d0f.svg";